import { render, staticRenderFns } from "./AttributionAccept.vue?vue&type=template&id=aee5b214"
import script from "./AttributionAccept.vue?vue&type=script&lang=js"
export * from "./AttributionAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports